"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDialogActions = void 0;
const DialogActionsDistribution_1 = require("../types/DialogActionsDistribution");
const getDialogActions = ({ distribution, primary, secondary }) => {
    if (distribution === DialogActionsDistribution_1.DIALOG_ACTIONS_DISTRIBUTION.start) {
        return {
            firstDialogActions: [...primary],
            secondDialogActions: [...secondary]
        };
    }
    if (distribution === DialogActionsDistribution_1.DIALOG_ACTIONS_DISTRIBUTION.end) {
        return {
            firstDialogActions: [...secondary],
            secondDialogActions: [...primary]
        };
    }
    return {
        firstDialogActions: [...primary],
        secondDialogActions: []
    };
};
exports.getDialogActions = getDialogActions;
//# sourceMappingURL=getDialogActions.js.map